<script setup lang="ts">
// Components of Module
import { YandexMapMarker } from 'vue-yandex-maps'

// Components
import { LngLat } from '@yandex/ymaps3-types'

// Types
import { PolygonProperties } from '@/api/modules/delivery/types'
import { IDeliveryDataAddress } from '@/store/delivery/delivery.types'

// Components
import BaloonTitle from '@/components/Services/Baloons/BaloonTitle.vue'

const BaloonTable = defineAsyncComponent(
  () => import('@/components/Services/Baloons/BaloonTable.vue'),
)

const props = defineProps({
  clickedMarkerCoordinates: {
    type: Object as PropType<LngLat>,
    required: true,
  },
  baloonInfo: {
    type: Object as PropType<PolygonProperties | null>,
    required: true,
  },
  selectedAddress: {
    type: Object as PropType<IDeliveryDataAddress | null>,
    required: true,
  },
})

const generateSettings = computed(() => {
  return {
    coordinates: props.clickedMarkerCoordinates,
    properties: { markerOfClick: true },
    zIndex: 1,
  }
})
</script>

<template>
  <yandex-map-marker
    :settings="generateSettings"
    position="top-center left-center"
  >
    <div class="marker">
      <div class="marker__band" />
      <div class="marker__baloon">
        <baloon-title
          :check-baloon-info="!!baloonInfo"
          :selected-address="selectedAddress"
        />

        <baloon-table v-if="baloonInfo" :baloon-info="baloonInfo" />
      </div>
    </div>
  </yandex-map-marker>
</template>

<style lang="scss" scoped>
.marker {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: auto;
  font-weight: 500;

  &__image {
    width: 35px;
    max-width: unset;
    height: 35px;
    cursor: pointer;
    background-size: cover;
    border-radius: 50%;
  }

  &__band {
    position: absolute;
    bottom: 100%;
    width: 2px;
    height: 20px;
    background: $text-black;
  }

  &__baloon {
    position: absolute;
    bottom: 20px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    width: auto;
    height: auto;
    min-height: 40px;
    padding: 12px 16px;
    font-size: 12px;
    font-weight: 500;
    line-height: 14px;
    color: $white;
    white-space: nowrap;
    background: $text-black;
    border-radius: 20px;
    box-shadow: 0 2px 20px #0000001a;
  }
}
</style>
